import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { useAdvertReviewCheckState } from '#reviewCheck/hooks';
import { reviewCheckHide, reviewCheckOpen } from '#reviewCheck/reducers';

const useAdvertReviewCheckVisibleControl = () => {
  const { isOpen } = useAdvertReviewCheckState();
  const dispatch = useDispatch();

  const triggerOpen = useCallback(() => {
    dispatch(reviewCheckOpen());
  }, [dispatch]);

  const triggerHide = useCallback((): Promise<void> => new Promise((resolve) => {
    dispatch(reviewCheckHide());

    setTimeout(() => {
      resolve();
    }, 400);
  }), [dispatch]);

  return {
    isOpen,
    open: triggerOpen,
    hide: triggerHide,
  };
};

export { useAdvertReviewCheckVisibleControl };
